import { type StyleProp, StyleSheet, Text, type TextStyle } from 'react-native';

import { tokens } from '../../tokens';
import { usePressableState } from '../pressable/pressable';

import { useButtonContext } from './button';

export type ButtonTextProps = {
  children: string | number | (string | number)[];
  style?: StyleProp<TextStyle>;
  testID?: string;
};
export function ButtonText(props: ButtonTextProps) {
  const buttonContext = useButtonContext();
  const pressableState = usePressableState();
  const disabledTextStyle =
    buttonContext.type === 'outline-inverted'
      ? buttonTextStyles.disabledInverted
      : buttonTextStyles.disabled;

  return (
    <Text
      style={[
        buttonTextStyles.baseline,
        buttonTextStyles[buttonContext.size],
        buttonTextStyles[buttonContext.type],
        buttonContext.type === 'ghost' && pressableState.hovered && buttonTextStyles.ghostHovered,
        buttonContext.disabled && disabledTextStyle,
        props.style,
      ]}
      testID={props?.testID}
    >
      {props.children}
    </Text>
  );
}

const buttonTextStyles = StyleSheet.create({
  baseline: {
    fontFamily: 'MontserratSemiBold',
    paddingHorizontal: 8,
    userSelect: 'none',
  },
  xs: {
    fontSize: 12,
  },
  sm: {
    fontSize: 12,
  },
  md: {
    fontSize: 14,
  },
  lg: {
    fontSize: 16,
  },
  xl: {
    fontSize: 18,
  },
  solid: {
    color: tokens.colors.$white,
  },
  'solid-inverted': {
    color: tokens.colors.$houseDark,
  },
  outline: {
    color: tokens.colors.$houseRed,
  },
  'outline-inverted': {
    color: tokens.colors.$white,
  },
  'outline-subtle': {
    color: tokens.colors.$houseDark,
  },
  ghost: {
    color: tokens.colors.$houseDark,
  },
  ghostHovered: {
    color: tokens.colors.$houseRed,
  },
  disabled: {
    color: tokens.colors.$disabledText,
  },
  disabledInverted: {
    color: tokens.colors.$whiteOpacity30,
  },
});
